import { createStructuredSelector } from 'reselect';
import {
	isConfluenceMacro,
	isEmbed,
	isExportMode,
	isOptimizedMode,
	isReportMode,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app';
import { getHierarchyTitles } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/hierarchy';
import {
	getIsGoalsLoading,
	getIssueGoalARIs,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issue-goals';
import { getIssueBeingEdited } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issue-modal';
import {
	getIssues,
	getIsIssuesLoading,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issues';
import {
	getActiveCard,
	getShouldDisplayTmpCrossProjectChangeboarding,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/onboarding';
import {
	getPlan,
	hasWarningInConfiguredDates,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/plan';
import { getTimelineExportWidth } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/section-widths';
import { getCurrentStickyHeaderGeometry } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/sticky-header';
import { getScopeHeight } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/table';
import { getZoomLevel } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/timeline';
import { getViewMode } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/view-settings';
import {
	getActiveView,
	getNamespaceFromActiveView,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/views';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import type { OwnProps, StateProps } from './types';

export default createStructuredSelector<State, OwnProps, StateProps>({
	activeCard: getActiveCard,
	activeView: getActiveView,
	exportModeTimelineWidth: getTimelineExportWidth,
	hasWarningInConfiguredDates,
	isConfluenceMacro,
	isEmbed,
	isExportMode,
	isLoading: getIsIssuesLoading,
	isOptimizedMode,
	isReportMode,
	issueBeingEdited: getIssueBeingEdited,
	issues: getIssues,
	scopeHeight: getScopeHeight,
	stickyHeader: getCurrentStickyHeaderGeometry,
	useTwpTeams: (state) => !!getPlan(state).useTwpTeams,
	viewNamespace: getNamespaceFromActiveView,
	zoomLevel: getZoomLevel,
	viewMode: getViewMode,
	issueGoalARIs: getIssueGoalARIs,
	shouldDisplayTmpCrossProjectChangeboarding: getShouldDisplayTmpCrossProjectChangeboarding,
	hierarchyTitles: getHierarchyTitles,
	// Rename to isGoalsLoading when plan_timeline_sort_goal_groups_alphabetically is cleaned up
	isGoalsLoadingNew: getIsGoalsLoading,
});
